import auth from "../middlewares/auth";
export const settings = [
    {
        path: '/settings',
        component: () => import(/* webpackChunkName: "notice" */ '../views/settings/Index'),
        name: 'settings',
        meta: {
            middleware: [
                auth
            ]
        }
    }
];
